import React from 'react';
import LocationSearchInput from 'modules/homescreen/components/LocationSearchInput';
import { addFlux, AddFluxHOCProps } from 'components/wrappers/WithFlux';
import { castleFFCities } from '../../../../constants';
import slugify from 'utils/slugify';
import Analytics from '@withlocals/withlocals-analytics';
import { Filter } from 'model/Filters';
import { createFilter } from 'data/filters';
import { compile } from 'utils/searchURLs';
import { history } from '../../../../wlHistory';
import { WlWindow } from '../../../../../typings/globals/cordova';
import { filtersToKeyword, filtersToMode } from 'data/keywords';
import getSearchPagePrefix from 'modules/homescreen/helpers/searchPagePrefix';
import { isCordova } from 'utils/platform';
import useIsMobile from '../../../../hooks/useIsMobile';
import useApprovedLocations from "hooks/useApprovedLocations";

declare const window: WlWindow;

interface SearchNavbarProps {
  filters: {
    activeFilters: Filter[];
    country: string;
    city: string;
    page: number;
  };
}

function onLocationAnalytics(searchMode: string, country: string, city?: string) {
  const destination = `${city ? city.toLowerCase() : (country || 'global').toLowerCase()}`;
  Analytics.track(window.currentPageCategory, JSON.stringify({ destination, searchMode }));
}

function getSearchPath(flux, filters, activeFilters, country, city, searchMode, isMobile, approvedLocations) {
  const forceOverviewPageVariant = isMobile && !isCordova();
  const isComingSoonCity = filters.city && filters.country && !!approvedLocations.find(f => f.isComingSoon && f.area === filters.city && f.country === filters.country);
  const searchPagePrefix = getSearchPagePrefix(filtersToMode(filters) || searchMode, isComingSoonCity, forceOverviewPageVariant);

  const searchPath = compile(country, city, 1, activeFilters);
  return `/${searchPagePrefix}${searchPath}`;
}

function NavbarSearchInput({ filters, flux }: SearchNavbarProps & AddFluxHOCProps) {
  const isMobile = useIsMobile();
  const { data: approvedLocations } = useApprovedLocations();
  const onLocationClick = () => {
    const currentFilters = flux.stores.FiltersStore.getFilters();
    const { country, city } = currentFilters;
    const activeFilters = [...currentFilters.activeFilters];

    const childrenFilter = activeFilters.find(activeFilter => activeFilter.uid === 'children');
    const children = childrenFilter ? childrenFilter.value : 0;
    if (city && castleFFCities.includes(slugify(city, false)) && children > 0) {
      activeFilters.push(createFilter('family-friendly'));
    }

    const searchMode = flux.stores.FiltersStore.getSearchMode();
    const url = getSearchPath(flux, currentFilters, activeFilters, country, city, searchMode, isMobile, approvedLocations);
    history.push(url);

    onLocationAnalytics(searchMode, country, city);
  };

  return (
    <LocationSearchInput
      city={filters.city}
      country={filters.country}
      place={filtersToKeyword(filters)}
      onSuggestionLockIn={onLocationClick}
      inNavbar
    />
  );
}

export default addFlux(NavbarSearchInput);
